import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../../constants/constants';
import AddFactorSetWeightLineForm from './factorSetCancellationLineForm';
import { resetCancellationVersionLines, resetFactorSetCancellationLine } from '../../../../reducers/cancellationLineReducer';

interface IAddFactorSetLineProps {
    classes: any;
    theme: Theme;
    match: any;
    cancellationLineId?: number;
    factorSetCancellationId?: number;
    resetCancellationVersionLines: any;
    resetFactorSetCancellationLine: any;
    factorSetVersionId?: number;
    type: FormType;
    steps: Array<number>;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetCancellationVersionLines: () => dispatch(resetCancellationVersionLines()),
    resetFactorSetCancellationLine: () => dispatch(resetFactorSetCancellationLine())
});

const mapStoreToProps = (store: RootState, ownProps: IAddFactorSetLineProps) => {
    return {
        cancellationLineId: ownProps.match.params?.cancellationLineId ? Number(ownProps.match.params?.cancellationLineId) : undefined,
        factorSetCancellationId: ownProps.match.params?.cancellationId ? Number(ownProps.match.params?.cancellationId) : undefined,
        factorSetVersionId: ownProps.match.params?.factorSetVersionId ? Number(ownProps.match.params?.factorSetVersionId) : undefined
    };
};

class AddFactorSetCancellationLine extends Component<IAddFactorSetLineProps> {

    componentWillUnmount() {
        const { resetCancellationVersionLines, resetFactorSetCancellationLine } = this.props;

        resetCancellationVersionLines();
        resetFactorSetCancellationLine();
    }

    render() {
        const { classes, steps, cancellationLineId, factorSetCancellationId, type, factorSetVersionId } = this.props;

        return (
            <div>
                <Card className={classes.root}>
                    <CardContent className={classes.cardContent}>
                        <AddFactorSetWeightLineForm cancellationLineId={cancellationLineId} factorSetCancellationId={factorSetCancellationId} steps={steps} type={type}
                            factorSetVersionId={factorSetVersionId} />
                    </CardContent>
                </Card>
            </div>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddFactorSetCancellationLine));